import React, { useEffect } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import Coin from '../../money-fiesta/images/links2/coin.png';
import Rich from '../../money-fiesta/images/links2/stacked coins.png';
import { useNavigate } from "react-router-dom";

const CashbackProgressBar = ({ currentAmount, goalAmount }) => {
  const progress = (currentAmount / goalAmount) * 100;
  // const navigate = useNavigate();



  // useEffect(() => {
  //   if (currentAmount >= goalAmount) {
  //     navigate('/money-fiesta/bonus');
  //   }
  // }, [currentAmount, goalAmount, navigate]);

  return (
    <Box position="relative" width="80%" maxWidth={600} mx="auto">
      {/* Progress Bar */}
      <Box position="relative" display="flex" alignItems="center">
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 15,
            borderRadius: 5,
            width: "100%",
            backgroundColor: "#fff",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#a700ab",
            },
          }}
        />

        {/* Current Position Indicator (Coin Image + Labels) */}
        {currentAmount !== goalAmount && <Box
          position="absolute"
          left={`${progress}%`}
          transform="translate(-50%, -50%)"
          top="-166%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{ marginLeft: "-4%" }}
        >
          {/* You are here Text */}
          <Typography
            sx={{
              fontSize: "8px",
              lineHeight: "10px",
              mb: "2px", // Small margin-bottom to move text up
              color: "white",
              textAlign: "center",
            }}
          >
            You are here
          </Typography>

          {/* Coin Image */}
          <img src={Coin} alt="coin" style={{ width: "40px", height: "40px" }} />

          {/* Current Amount */}
          <Typography variant="caption" color="white">
            ₹{currentAmount}
          </Typography>
        </Box>}
        <Box
          position="absolute"
          // left={`${progress}%`}
          transform="translate(-50%, -50%)"
          right="0px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{ marginRight: "-10%" }}
        >
          {/* You are here Text */}
          <Typography
            sx={{
              fontSize: "8px",
              lineHeight: "10px",
              mb: "2px", // Small margin-bottom to move text up
              color: "white",
              textAlign: "center",
            }}
          >
            {currentAmount === goalAmount ? "You are here" : "Cashback Goal"}
          </Typography>

          {/* Coin Image */}
          <img src={Rich} alt="coin" style={{ width: "40px", height: "40px" }} />

          {/* Current Amount */}
          <Typography variant="caption" color="white">
            ₹{goalAmount}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default function App(props) {
  return (
    <Box
      mt={5}
      mb={5}
      sx={{
        // backgroundColor: "#0A0A2A",
        // height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CashbackProgressBar currentAmount={props.current} goalAmount={props.goal} />
    </Box>
  );
}
